import { HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CachableRoutes } from 'src/app/shared/constants/cachableRoutes';

@Injectable({
    providedIn: 'root'
})
export class HttpCacheService  {
    cache: { [key: string]: HttpResponse<any> } = {};
    cachableRoutes = CachableRoutes.getCachableRoutes();

    constructor() {}

    // Get an item from the cache
    get(request: HttpRequest<any>): HttpResponse<any> {
        const cachedItem = this.shouldCache(request.urlWithParams)
        if (cachedItem) {
            const cachedData = this.cache[request.urlWithParams+';'+JSON.stringify(request.body)]
            if(cachedData){
                return cachedData;
            }
            return null;
        }
        return null;
    }

    // Put an item in the cache
    put(request: HttpRequest<any>, response: HttpResponse<any>): void {
        const urlWithBody = request.urlWithParams+';'+JSON.stringify(request.body);
        const shouldCache = this.shouldCache(request.urlWithParams);
        if (shouldCache) {
            this.cacheToLocal(urlWithBody, response);
        }
    }

    // Delete an item from the cache
    delete(request: HttpRequest<any>): boolean {
        const cachedRequest = this.get(request);
        let returnVal = false;
        if (cachedRequest) {
            delete this.cache[request.urlWithParams];
            returnVal = true;
        }
        return returnVal;
    }

     
    // Delete all item from the cache     
    clearAllCache(){
        if(this.cache)
            this.cache={};
    }

    // Determine if a url SHOULD be cached or not. It must match a route pattern provided in
    shouldCache(urlWithParams: string) {
        let shouldCache = false;
        Object.values(this.cachableRoutes).forEach((pattern) => {            
            if(urlWithParams.indexOf(pattern.toString())>-1){
                shouldCache = true;
            }
        });
        return shouldCache;
    }

    // Place the response in the local `cache` variable
    cacheToLocal(urlWithParams: string, response: HttpResponse<any>) {
        this.cache[urlWithParams] = response;
    }
}